import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Card from "../../components/JobCard";
import { useNavigate, useLocation } from "react-router-dom";
import CircularLoader from "../../components/loader";
import HomeHeader from "../../components/HomeHeader";
import axios from "axios";

function PausedJobs() {
  const navigate = useNavigate();
  const location = useLocation();
  const [pausedJobs, setPausedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const headerTitle = location?.state || "Paused Jobs";

  const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const fetchJobs = async () => {
      try {
        const response = await axios.get("https://jobmanagement-497524552274.us-central1.run.app/api/jobs/list", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        // Filter only paused jobs
        const pausedJobsData = response.data.filter((job) => job.status === "PAUSED");

        setPausedJobs(pausedJobsData);
      } catch (err) {
        setError("Failed to fetch jobs. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [token, navigate]);

  const handleViewDetails = (jobId) => {
    navigate(`/job-details/${jobId}`);
  };

  return (
    <>
      {loading && <CircularLoader position="loaderMiddle" />}
      {error && <div>{error}</div>}
      <Grid margin="5%" bgcolor="#FFFFFF">
        <Grid pb={1} display="flex" alignItems="center">
          <HomeHeader header={headerTitle} />
        </Grid>

        {pausedJobs.length > 0 ? (
          <Grid>
            {pausedJobs.map((job, i) => (
              <div key={job.id}>
                <div>Job ID: {job.id}</div>
                <Card
                  key={i}
                  headerTitle={headerTitle}
                  showTitle={true}
                  profile={false}
                  data={job}
                  onViewDetails={() => handleViewDetails(job.id)}
                />
              </div>
            ))}
          </Grid>
        ) : (
          <p>No paused jobs available.</p>
        )}
      </Grid>
    </>
  );
}

export default PausedJobs;
